import React, { useEffect, useState } from "react";
import { getInternshipRequest, getJoinDataByCompany } from "./../api/crud";
import _ from "lodash";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Avatar, Drawer } from "@mui/material";
import { convertDateToString, matchOptions } from "./../utils/function";
import { optionsBranch } from "./../data/branch-data";
import { internType } from "./../data/interntype-data";
import DrawerView from "./../Components/DrawerView";
import FormResponse from "./../Components/FormResponse";
import InternPersonsQty from "./../Components/InternPersonsQty";
import ProfileDetail from "./../Components/ProfileDetail";
import InternData from "./../Components/InternData";
import ActivityLog from "./../Components/ActivityLog";
import { generateStatus } from "../utils/generateDisplay";
import TaskStatusCard from "../Elements/TaskStatusCard";
import FormTransfer from "../Components/FormTransfer";
import ProvinceDetailModal from "../Components/ProvinceDetailModal";
import CoopCompanyModal from "../Components/CoopCompanyModal";
import StudentListDrawer from "../Components/StudentListDrawer";
import { IoMdRemoveCircle, IoMdAddCircle } from "react-icons/io";
import { currentYear } from "../data/config";

const DashboardCompany = () => {
  const [isOpenDrawerFormResponse, setIsOpenDrawerFormResponse] =
    useState(false);
  const [companySelected, setCompanySelected] = useState(null);
  const [isOpenTransferDrawer, setIsOpenTransferDrawer] = useState(false);
  const [isProvinceModalOpen, setIsProvinceModalOpen] = useState(false);
  const [isCoopCompanyModalOpen, setIsCoopCompanyModalOpen] = useState(false);
  const [isStudentDrawerOpen, setIsStudentDrawerOpen] = useState(false);
  const [selectedCompanyStudents, setSelectedCompanyStudents] = useState(null);

  // add by SE
  const optionsNewBranch = [
    {
      label: "ทั้งหมด",
      value: 0,
    },
    ...optionsBranch,
  ];
  const onHandleBranchSelect = (data) => {
    setBranchSelected(data);
  };
  const [branchSelected, setBranchSelected] = useState(optionsNewBranch[0]);

  // add by SE

  const [docSelected, setDocSelected] = useState(null);
  const profile = useSelector((state) => state.profileReducer.profile);

  const [docRequestList, setDocRequestList] = useState([]);
  const [docRequestFilter, setDocRequestFilter] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [joinDataByCompany, setJoinDataByCompany] = useState([]);
  const [studentSelected, setStudentSelected] = useState(null);
  const [provinceList, setProvinceList] = useState([]);
  const [internshipRequestList, setInternshipRequestList] = useState([]);
  const [numCompanyCoop, CountNumCompanyCoop] = useState([]);
  const [numStdCoop, CountNumStdCoop] = useState([]);
  const [numStdAll, CountNumStdAll] = useState([]);
  const [removeStudent, setRemoveStudent] = useState([]);

  const onHandleSearch = (ev) => {
    const { value } = ev.target;

    setSearchTerm(value);

    const results = docRequestList.filter((el) => {
      return (
        el.id.toLowerCase().includes(value.toLowerCase()) ||
        el.name.toLowerCase().includes(value.toLowerCase()) ||
        el.province.toLowerCase().includes(value.toLowerCase())
      );
    });

    setDocRequestFilter(results);
  };

  const getData = async () => {
    const internshipRequest = await getInternshipRequest();
    const dataByCompany = await getJoinDataByCompany();
    const dataByCompanyWithStd = dataByCompany
      .filter((el) => el.internStudent.length)
      .map((item) => {
        return {
          ...item,
          province: item.province.trim(),
        };
      });

    const activeInternshipRequest = internshipRequest.filter(
      (el) => el.req_id
      // (el) => el.status !== "0" && el.req_id
    );

    const filterInActiveStudent = dataByCompanyWithStd.map((el) => {
      if (branchSelected?.value != 0) {
        return {
          ...el,
          internStudent: el.internStudent.filter(
            (st) =>
              st.status_id !== "14" &&
              st.status_id !== "15" &&
              st.status_id !== "32" &&
              st.b_id == branchSelected.value
          ),
        };
      } else {
        return {
          ...el,
          internStudent: el.internStudent.filter(
            (st) =>
              st.status_id !== "14" &&
              st.status_id !== "15" &&
              st.status_id !== "32"
          ),
        };
      }
    });

    const filterCompanyWithStd = filterInActiveStudent.filter(
      (el) => el.internStudent.length
    );

    const uniqProvince = _.uniqBy(filterCompanyWithStd, function (e) {
      return e.province;
    });

    const onlyProvince = uniqProvince.map((data) => data.province);

    setProvinceList(onlyProvince.sort((a, b) => a.localeCompare(b)));

    var numCompanyCoop = 0;
    var numStdCoop = 0;
    var numStd = 0;
    for (let i = 0; i < filterCompanyWithStd.length; i++) {
      const stdGroup = filterCompanyWithStd[i].internStudent?.filter(
        (el) =>
          el.internDetail.type_internship == "2" ||
          el.internDetail.type_internship == "3"
      );
      const stdAll = filterCompanyWithStd[i].internStudent?.filter(
        (el) => el.internDetail
      );
      numStdCoop += stdGroup.length;
      numStd += stdAll.length;
      if (stdGroup.length > 0) {
        numCompanyCoop += 1;
      }
    }

    CountNumCompanyCoop(numCompanyCoop);
    CountNumStdCoop(numStdCoop);
    CountNumStdAll(numStd);
    setInternshipRequestList(activeInternshipRequest);
    setJoinDataByCompany(dataByCompany);

    setDocRequestList(filterCompanyWithStd);
    setDocRequestFilter(filterCompanyWithStd);
  };

  const onCreateFormTransfer = (company) => {
    setIsOpenTransferDrawer(true);
    setCompanySelected(company);
  };

  const onRemoveStudent = (stId) => {
    setRemoveStudent((std) => [...std, stId]);
  };

  const handleProvinceCardClick = () => {
    setIsProvinceModalOpen(true);
  };

  const handleCoopCompanyCardClick = () => {
    setIsCoopCompanyModalOpen(true);
  };

  const handleStudentClick = (company) => {
    setSelectedCompanyStudents({
      company: company,
      students: company.coopStudents
    });
    setIsStudentDrawerOpen(true);
  };

  const handleCloseStudentDrawer = () => {
    setIsStudentDrawerOpen(false);
    setSelectedCompanyStudents(null);
  };

  // สร้างข้อมูลจังหวัดพร้อมจำนวนบริษัท
  const getProvinceData = () => {
    return provinceList.map(province => {
      const companiesInProvince = docRequestList.filter(company => company.province === province);
      return {
        name: province,
        count: companiesInProvince.length,
        companies: companiesInProvince // เพิ่มข้อมูลบริษัทใน province
      };
    });
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getData();
  }, [branchSelected]);

  useEffect(() => {
    if (profile && profile.b_id) {
      const matchBranch = optionsBranch.find(
        (opt) => opt.value == profile.b_id
      );

      setBranchSelected(matchBranch);
    }
  }, [profile]);

  return (
    <div className="main">
      <main className="content">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center my-3">
            <h3>
              สรุปการฝึกงานและสหกิจศึกษา ปีการศึกษา {currentYear} -
              แยกตามสถานประกอบการ
            </h3>

            {/* // add by SE */}
            <div className="">
              <Select
                options={optionsNewBranch}
                value={branchSelected}
                onChange={onHandleBranchSelect}
                isDisabled={profile && profile.b_id == 0 ? false : true}
              />
            </div>
            {/* // add by SE */}
          </div>
          <div className="d-flex gap-2">
            <TaskStatusCard
              cardWidth="300px"
              title="สถานประกอบการทั้งหมด"
              data={docRequestFilter.length}
            />
            <TaskStatusCard
              cardWidth="300px"
              title="จังหวัดที่ตั้งของสถานประกอบการ"
              data={provinceList.length}
              onClick={handleProvinceCardClick}
            />

            <TaskStatusCard
              cardWidth="300px"
              title="สถานประกอบการที่รับสหกิจศึกษา"
              data={numCompanyCoop}
              total={docRequestFilter.length}
              onClick={handleCoopCompanyCardClick}
              //
            />
            <TaskStatusCard
              cardWidth="300px"
              title="จำนวนนิสิตสหกิจศึกษา"
              data={numStdCoop}
              total={numStdAll}
            />
          </div>
          <div className="d-flex flex-row-reverse col-md-2  my-3">
            <input
              className="form-control"
              placeholder="ค้นหา"
              onChange={onHandleSearch}
              defaultValue={searchTerm}
            />
          </div>
          <div>{!!searchTerm && `พบ ${docRequestFilter.length} ผลลัพธ์`} </div>

          <div className="card flex-fill" style={{ overflowX: "scroll" }}>
            <table
              id="datatables-dashboard-projects"
              className="table table-striped my-0 table-hover"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th style={{ minWidth: "400px" }}>สถานประกอบการ</th>
                  <th>รายชื่อนิสิต</th>
                  <th>สถานะ</th>
                  <th style={{ width: "400px" }}>ผู้ประสานงาน</th>
                  {/* <th>สถานะ</th> */}
                </tr>
              </thead>

              <tbody>
                {docRequestFilter?.map((res, index) => {
                  const newStList = _.remove(
                    res.internStudent.map((s) => s.id),
                    (n) => {
                      return removeStudent.indexOf(n) == -1;
                    }
                  );

                  return (
                    <tr key={res.idm_doc_id}>
                      <td>{index + 1}</td>
                      <td
                        style={{ verticalAlign: "top" }}
                        className="text-wrap border p-2"
                      >
                        <div className="fw-bolder text-dark p-0">
                          <span class="badge badge-soft-dark"> {res.id}</span>
                          {res.name}
                          <InternPersonsQty
                            companyDetail={joinDataByCompany.find(
                              (c) => c.id == res.id
                            )}
                          />
                        </div>
                        <div className="p-0">
                          {res?.address} ต.
                          {res?.subdistrict} อ.
                          {res?.district} จ.
                          {res?.province} {res?.zip}
                        </div>
                      </td>

                      <td style={{ verticalAlign: "top" }} className="p-2">
                        {res.internStudent.map((st, stIndex) => {
                          return (
                            <tr
                              className=""
                              key={stIndex}
                              style={{ height: "100px" }}
                            >
                              <td className={``}>
                                <div className="d-flex align-items-center justify-content-between my-2">
                                  <div className="d-flex align-items-top">
                                    <div>
                                      <Avatar
                                        onClick={() => setStudentSelected(st)}
                                        role="button"
                                        alt={st.name}
                                        sx={{ height: 40, width: 40, mr: 2 }}
                                        src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${st.id}`}
                                      />
                                    </div>
                                    <div>
                                      <div className="text-nowrap">
                                        {st?.id} {st?.name}
                                      </div>
                                      <div className="badge bg-info">
                                        {matchOptions(optionsBranch, st.b_id)}
                                      </div>
                                      {/* <div>{generateStatus(st.status_id)}</div> */}
                                      <div>
                                        <span className="badge bg-secondary ">
                                          {matchOptions(
                                            internType,
                                            st?.internDetail?.type_internship
                                          )}
                                        </span>
                                      </div>
                                      <div>
                                        <span className="badge bg-warning text-dark bg-opacity-25">
                                          {convertDateToString(
                                            st.internDetail.start_date
                                          )}{" "}
                                          ถึง
                                          {convertDateToString(
                                            st.internDetail.end_date
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </td>

                      <td style={{ verticalAlign: "top" }} className="p-2">
                        {res.internStudent.map((st, stIndex) => {
                          return (
                            <tr
                              className=""
                              key={stIndex}
                              style={{ height: "100px" }}
                            >
                              <td>
                                <div>{generateStatus(st.status_id)}</div>
                              </td>
                            </tr>
                          );
                        })}
                      </td>
                      <td style={{ verticalAlign: "top" }} className="p-2">
                        {res.internStudent.map((st, stIndex) => {
                          return (
                            <tr
                              className=""
                              key={stIndex}
                              style={{ height: "100px" }}
                            >
                              <td>
                                <div>{st.internDetail.co_name}</div>
                                <div>{st.internDetail.co_email}</div>
                                <div>{st.internDetail.cp_tel}</div>
                              </td>
                            </tr>
                          );
                        })}
                      </td>

                      {/* <td style={{ verticalAlign: "top" }} className="p-2">
                        {res.internStd.map((st, stIndex) => {
                          return (
                            <tr
                              className=""
                              key={stIndex}
                              style={{ height: "100px" }}
                            >
                              <td className={``}>
                                <div className="d-flex align-items-center justify-content-between my-2">
                                  <div>
                                    <span className="badge bg-warning bg-opacity-75 text-dark">
                                      {matchOptions(
                                        optionsStatus,
                                        st.internStudent.status_id
                                      )}
                                    </span>

                              
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </td> */}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </main>

      <DrawerView
        isOpen={isOpenDrawerFormResponse}
        setIsOpen={setIsOpenDrawerFormResponse}
        content={<FormResponse data={docSelected} editable />}
      />

      <Drawer
        anchor="right"
        open={studentSelected ? true : false}
        onClose={() => setStudentSelected(null)}
      >
        <div
          className="card-body shadow-lg"
          style={{ width: "80vw", maxWidth: "600px" }}
        >
          <div className="row g-0">
            <div className="col-12 mb-4">
              <ProfileDetail st_id={studentSelected?.id} />
            </div>
            <div className="col-12 ">
              <InternData st_id={studentSelected?.id} />
            </div>
          </div>

          <hr />
          <ActivityLog />
        </div>
      </Drawer>

      {/* Province Detail Modal */}
      <ProvinceDetailModal
        open={isProvinceModalOpen}
        onClose={() => setIsProvinceModalOpen(false)}
        data={getProvinceData()}
        totalCompanies={docRequestFilter.length}
      />

      {/* Coop Company Modal */}
      <CoopCompanyModal
        open={isCoopCompanyModalOpen}
        onClose={() => setIsCoopCompanyModalOpen(false)}
        companies={docRequestFilter}
        onStudentClick={handleStudentClick}
      />

      {/* Student List Drawer */}
      <StudentListDrawer
        open={isStudentDrawerOpen}
        onClose={handleCloseStudentDrawer}
        selectedCompanyStudents={selectedCompanyStudents}
      />
    </div>
  );
};

export default DashboardCompany;
